import TextInput from './TextInput';
import {
    AttrFieldProps,
    ComponentProps,
    HandleChange,
    HandleChangeOptions,
} from '../../@types/attributeFields';
import useProperty from '@hooks/useProperty';

const AttrField = <T extends ComponentProps>({
    name,
    Component = TextInput,
    property = 'attributes',
    path,
    placeholderSrc = '',
    fallback = null,
    ...props
}: AttrFieldProps<T>) => {
    const { getProperty, setProperty, getGlobalProperty } = useProperty(
        name,
        property,
        path,
    );

    const value = getProperty();

    const handleChange: HandleChange = (
        valueOrEvent,
        options: HandleChangeOptions = {},
    ) => {
        let value =
            typeof valueOrEvent === 'string'
                ? valueOrEvent
                : valueOrEvent?.target?.value;
        const { prefix, suffix } = options;

        if (!value) {
            setProperty(fallback);
            return;
        }

        if (prefix) value = prefix + value;
        if (suffix) value = value + suffix;
        setProperty(value);
    };

    return (
        <Component
            name={`${property}.${name}`}
            value={value}
            placeholder={getGlobalProperty(placeholderSrc)}
            {...props}
            onChange={handleChange}
        />
    );
};

export default AttrField;
